<template>
<div class="content-class">
	<v-tabs v-model="active" color="black" dark slider-color="primary">
		<v-tab :key="'dashboard'" ripple>Vue d'ensemble</v-tab>
		<v-tab :key="'users'" ripple>Utilisateurs</v-tab>
		<v-tab :key="'variables'" ripple>Variables</v-tab>
		<v-tab :key="'subBot'" ripple>Configuration</v-tab>
		<v-tab :key="'message'" ripple>Message d'envoi</v-tab>
		<v-tab :key="'Logs'" ripple>Logs</v-tab>

		<v-tab-item :key="'dashboard'">
			<dashboard type="subBot"></dashboard>
		</v-tab-item>

		<v-tab-item :key="'users'">
			<user-list :url="'users?filter=bots.bot:$eq:'+$route.params.botId+';navigationVariables.subBot:$eq:'+$route.params.subBotId">
			</user-list>
		</v-tab-item>

		<v-tab-item :key="'variables'">
			<bot-variable-list :url="'botVariables?filter=subBot:$eq:'+$route.params.subBotId">
			</bot-variable-list>
		</v-tab-item>

		<v-tab-item :key="'subBot'">
			<sub-bot-form v-model="document">
			</sub-bot-form>
		</v-tab-item>

		<v-tab-item :key="'message'">
			<message-form :is-asko="$store.state.bot.bot.isAsko" :sub-bot-id="$route.params.subBotId" :base-message="document ? document.message: ''">
			</message-form>
		</v-tab-item>

		<v-tab-item :key="'Logs'">
			<log-list :url="'logs?filter=references.reference:$eq:subBots;references.referenceId:$eq:'+$route.params.subBotId">
			</log-list>
		</v-tab-item>
	</v-tabs>
</div>
</template>
<script>
import SubBotForm from '../../components/subBots/subBot.form'
import MessageForm from '../../components/subBots/message.form'
import BotVariableList from '../../components/botVariables/botVariable.list'
import LogList from '../../components/logs/log.list.vue'
import UserList from '../../components/users/user.list'
import Dashboard from '../../components/dashboard/dashboard'

import { ERROR } from '../../variables'

export default {
	components: { UserList, BotVariableList, SubBotForm, LogList, Dashboard, MessageForm },
	data() {
		return {
			loading: false,
			active: null,
			document: null
		}
	},
	mounted() {
		this.axios
			.get('subBots/' + this.$route.params.subBotId)
			.then(response => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	}

}
</script>
<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/subBots/subBots.detail.vue